import { Duration } from '@/components/common/duration-select'
import { Nullable } from '@/types/nullable'
import { KpiSchema } from '@/types/schema/kpi-schema'

type GetValuation = (
  duration: Duration.ThreeMonths | Duration.SixMonths,
  kpi?: KpiSchema,
) => Nullable<number>

export const getPostValuation: GetValuation = (duration, kpi) => {
  if (!kpi) {
    return null
  }

  const { postWordOfMouthVolume3m = 0, postWordOfMouthVolume6m = 0 } = kpi
  return duration === Duration.ThreeMonths
    ? postWordOfMouthVolume3m
    : postWordOfMouthVolume6m
}

export const getVideoValuation: GetValuation = (duration, kpi) => {
  if (!kpi) {
    return null
  }

  const { videoWordOfMouthVolume3m = 0, videoWordOfMouthVolume6m = 0 } = kpi
  return duration === Duration.ThreeMonths
    ? videoWordOfMouthVolume3m
    : videoWordOfMouthVolume6m
}
